import axios from "axios";
import {REPORT_TEMPLATE_MODULE_API_URL} from "../constants/api_routes";
import {getHeader} from "./user_api";

export const createModuleForReportTemplate = async (formData) => {
    try {
        const response = await axios.post(`${REPORT_TEMPLATE_MODULE_API_URL}/create`, formData, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            success: false,
            message: e.response
        }
    }
};

export const getModulesList = async () => {
    try {
        const response = await axios.get(`${REPORT_TEMPLATE_MODULE_API_URL}/list`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };    }
};

export const updateModule = async (formData) => {
    try {
        const response = await axios.post(`${REPORT_TEMPLATE_MODULE_API_URL}/update`,formData, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const deleteModule = async (id) => {
    try {
        const response = await axios.delete(`${REPORT_TEMPLATE_MODULE_API_URL}/delete?id=${id}`,{headers: getHeader()});
        return response;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const getModuleDetail =  async (id) => {
    try {
    const response = await axios.get(`${REPORT_TEMPLATE_MODULE_API_URL}/detail?id=${id}`, {headers: getHeader()});
    return response.data;
    } catch (e) {
        return {
            success: false,
            message: e.response
        }
    }
};


// WEBPACK FOOTER //
// ./src/data/report_module_api.js